import { render } from "./Personalmodal.vue?vue&type=template&id=4962d70a"
import script from "./Personalmodal.vue?vue&type=script&lang=js"
export * from "./Personalmodal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__